import useChemicalProductQuery from '@behavior/chemicalProducts/useGetChemicalProductQuery';
import { Icon } from 'semantic-ui-react';
import styles from './styles/Activity.module.scss';
import { useTranslation } from 'react-i18next';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import { InputWrapper } from 'react-lib/dist/components-es';
import { useState, useEffect } from 'react';
import HazardIcon from '@components/Filtering/OverviewTable/InventorySimplifiedView/Components/HazardIcon';
import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';
import { Popup } from 'semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { ChemicalProduct } from '@src/routes';

type Props = {
  chemicalProductId: number;
  onRemove?: () => void;
  chemicalProductsList?: ActivityChemicalsDTO[];
  setChemicalProductsList?: (chemicalProductsList: ActivityChemicalsDTO[]) => void;
  disabled?: boolean;
  activityId?: number;
};

const ChemicalDetailsCard = ({
  activityId,
  chemicalProductId,
  onRemove,
  chemicalProductsList,
  setChemicalProductsList,
  disabled,
}: Props) => {
  const { data: chemicalProduct } = useChemicalProductQuery(chemicalProductId);
  const { t } = useTranslation();
  const [chemicalState, setChemicalState] = useState('');
  const { hazards } = chemicalProduct || {};

  useEffect(() => {
    if (chemicalProduct?.state.name === 'STATE_GAS') {
      setChemicalState('activity.details.page.components.activity.chemical.gas');
    } else if (chemicalProduct?.state.name === 'STATE_LIQUID') {
      setChemicalState('activity.details.page.components.activity.chemical.liquid');
    } else {
      setChemicalState('activity.details.page.components.activity.chemical.solid');
    }
    if (chemicalProduct && !disabled) {
      const newItem: ActivityChemicalsDTO = {
        id: null,
        chemicalProduct: chemicalProduct,
        activityId: activityId || null,
      };
      if (chemicalProductsList) {
        const isAlreadyInList = chemicalProductsList.some(
          item => item.chemicalProduct.id === chemicalProduct.id
        );

        if (!isAlreadyInList && setChemicalProductsList) {
          const updatedList = [...chemicalProductsList, newItem];
          setChemicalProductsList(updatedList);
        }
      }
    }
  }, [chemicalProduct]);

  return (
    <div className={styles.basicDiv}>
      <div className={styles.flexContainerActivity}>
        <div className={styles.chemicalTextHeader}>
          {t('chemical.product.details.page.chemical.container.title')}
          {chemicalProduct && chemicalProduct.id && (
            <Popup
              className="inlineSiblingDivs"
              key="chemical.product.button.tooltip"
              trigger={
                <Button
                  type="button"
                  icon="icon-bond-list"
                  className="marginLeftButton mini"
                  onClick={() =>
                    window.open(`${ChemicalProduct.baseName}/view/${chemicalProduct?.id}`, '_blank')
                  }
                />
              }
              on={['hover']}
              size="mini"
              content={t('details.chemical.product.button.tooltip')}
              position="bottom left"
            />
          )}
        </div>
        {!disabled && (
          <div className={styles.closeButton}>
            <Icon name="close" size="small" color="blue" onClick={onRemove} />
          </div>
        )}
      </div>
      <div className={styles.flexContainerActivity}>
        <div className={styles.chemicalProductDetailsTradeName}>
          <GridColumnInputWrapper
            value={chemicalProduct?.tradeName || ''}
            name="chemicalProduct.tradeName"
            label="chemical.product.details.page.chemical.container.trade.name.input"
            disabled={true}
            specialRequiredCondition={true}
            render={(props: any) => <InputWrapper {...props} />}
          />
        </div>
        <div className={styles.chemicalProductDetailsState}>
          <GridColumnInputWrapper
            value={t(`${chemicalState}`)}
            name="chemicalProduct.state.id"
            label="chemical.product.details.page.chemical.container.state.input"
            disabled={true}
            propUsedInChanges="name"
            render={(props: any) => <InputWrapper {...props} />}
          />
        </div>
      </div>
      <div className={styles.chemicalProductDetailsChemicalName}>
        <GridColumnInputWrapper
          value={chemicalProduct?.chemicalName || ''}
          name="chemicalProduct.chemicalName"
          label="chemical.product.details.page.chemical.container.chemical.name.input"
          disabled={true}
          specialRequiredCondition={true}
          render={(props: any) => <InputWrapper {...props} />}
        />
      </div>
      <div className={styles.hazardsDiv}>
        <label className={styles.spanStyle}>
          {t('chemical.product.details.page.hazards.container.title')}{' '}
        </label>
        {hazards && Array.isArray(hazards) && <HazardIcon hazards={hazards} />}
      </div>
    </div>
  );
};

export default ChemicalDetailsCard;
